<div class="main-wrapper {{'lang' | translate }}" [ngClass]="setMainClass">
  <app-header [lottoId]="lottoIdClass" [sys]="systemClass"></app-header>
  <ng-content></ng-content>
</div>
